module.exports = __webpack_public_path__ + "img/silver-medal.13411d91.gif";